import { State } from "../Area/state";
import { SibBaseObject } from "../BaseObject/SibBaseObject";
import { Group } from "../group/group";
import { Picture } from '../hoardings/picture';
import { Industry } from "../industry/industry";
import { PptConfig } from '../ppt/ppt-config';
import { UserWrapper } from '../user/user-wrapper';
import { GSTDetail } from "./GSTDetails";
import { PointOfContact } from "./pointofcontact";

export class Customer extends SibBaseObject {
    //Push trigger
    gst: string;
    pan: string;
    company: string;
    billingName: string;
    industry: Industry = new Industry();
    group: Group = new Group();
    address1: string;
    address2: string;
    city: any;
    district: any;
    state: State = new State();
    postalCode: string;
    contactNumber: string;
    faxNumber: string;
    website: string;
    emailId: string;
    facebookUrl: string;
    linkedinUrl: string;
    pocs: PointOfContact[] = [];
    managers: UserWrapper[] = [];
    image?: any;
    mobileNumber: string;
    status: any;
    gstDetails: GSTDetail[] = [];
    dndFlag: boolean = false;

    profileImage: Picture = new Picture();
    // profileImage: Picture[] = [];
    customerId: string;
    pptConfigPresent: boolean;
    pptConfig: PptConfig = new PptConfig();
    agency: boolean;
}
